import React from "react";
import { Box } from "@mui/material";
import FaqContent from "./FaqContent";

const container = {
    height: "100vh",
    bgcolor: "#f5f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

const card = {
    width: "420px",
    maxWidth: "95%",
    height: "97vh",
    bgcolor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    overflowY: "auto",
    p: 2,
};

const contentStyles = {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "#333",

    "& h1": {
        fontSize: "20px",
        fontWeight: "bold",
        margin: "12px 0 8px",
        lineHeight: 1.4,
        letterSpacing: "normal",
        wordBreak: "break-word",
        fontFamily: "inherit",
    },

    "& h2": {
        fontSize: "16px",
        fontWeight: "bold",
        margin: "16px 0 8px",
        lineHeight: 1.5,
        letterSpacing: "normal",
        wordBreak: "break-word",
        fontFamily: "inherit",
    },

    "& h3": {
        fontSize: "14px",
        fontWeight: "bold",
        margin: "12px 0 4px",
        lineHeight: 1.7,
        letterSpacing: "normal",
        wordBreak: "break-word",
        fontFamily: "inherit",
    },

    "& p": {
        fontSize: "13px",
        marginBottom: "6px",
        wordBreak: "break-word",
        lineHeight: 1.7,
    },

    "& a": {
        color: "#1976d2",
        textDecoration: "underline",
        wordBreak: "break-all",
        fontSize: "13px",
    },
};

const FAQ = () => {
    return (
        <Box sx={container}>
            <Box sx={card}>
                <Box sx={contentStyles}>
                    <FaqContent />
                </Box>
            </Box>
        </Box>
    );
};

export default FAQ;